import {
  type PosthogExceptionEntry,
  type PosthogExceptionFrame,
  exceptionValue,
} from "./posthog-exception-types";

const GOOGLE_RPC_TRANSPORT_FAILURE = "Rpc failed due to xhr error";
const GOOGLE_RPC_URI_PATTERN = /uri:\s*https:\/\/[\w.-]+\.googleapis\.com\/\$rpc\//;

export function isGoogleMapsRpcTransportNoiseValue(value: string): boolean {
  if (!value.includes(GOOGLE_RPC_TRANSPORT_FAILURE)) return false;
  return GOOGLE_RPC_URI_PATTERN.test(value);
}

const GOOGLE_MAPS_BUNDLE_PATH = "maps-api-v3/";

function isGoogleMapsBundleFrame(frame: PosthogExceptionFrame): boolean {
  return [frame.filename, frame.abs_path, frame.source].some((path) =>
    path?.includes(GOOGLE_MAPS_BUNDLE_PATH),
  );
}

function isFirstPartyFrame(frame: PosthogExceptionFrame): boolean {
  if (isGoogleMapsBundleFrame(frame)) return false;
  if (frame.in_app === true) return true;
  if (frame.in_app === false) return false;
  const path = frame.filename ?? frame.abs_path ?? "";
  return path.includes("_next/") || path.startsWith("app:///");
}

function isGoogleMapsTransportEntry(entry: PosthogExceptionEntry): boolean {
  if (!isGoogleMapsRpcTransportNoiseValue(exceptionValue(entry))) return false;
  return !(entry.stacktrace?.frames ?? []).some(isFirstPartyFrame);
}

export function isGoogleMapsRpcTransportNoisePosthog(
  list: Array<PosthogExceptionEntry>,
): boolean {
  return list.length > 0 && list.every(isGoogleMapsTransportEntry);
}
